import React from "react";
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { useAuth } from "../../hooks/useAuth";
import { refreshSession } from "../../services/sessions";
import { useSelectMenu } from "../../services/Redirect";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function SignAsUser(props) {
  const { selectMenuShort } = useSelectMenu({ reload: true });
  const { token } = useParams();
  const { persistUser } = useAuth();
  const navigate = useNavigate();
  let query = useQuery();
  const shortToRedirect = query.get("shortToRedirect");

  useEffect(() => {
    async function loadStorageData(): Promise<void> {
      const userToken: any = jwtDecode(token as string);
      const response = await refreshSession({
        token: token as string,
        userId: userToken?.user_id,
      });
      const { user, permissions } = response;

      await persistUser(user, permissions, token as string);
      if (shortToRedirect) {
        if (shortToRedirect === "sair") {
          props.setLogged(false);
          localStorage.clear();
          navigate("/");
        }
        selectMenuShort(shortToRedirect);
      } else {
        navigate("/");
      }
    }
    loadStorageData();
  }, [token, navigate, persistUser, selectMenuShort, props, shortToRedirect]);

  return <Preload loading />;
}
